// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ebf23b6b","809":"943722e5","929":"c5b86648","990":"849475b4"}[chunkId] + ".chunk.js";
};